import { render, staticRenderFns } from "./ConfiguracaoGerentesComerciais.vue?vue&type=template&id=e8131fcc&scoped=true&lang=pug"
import script from "./ConfiguracaoGerentesComerciais.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoGerentesComerciais.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracaoGerentesComerciais.vue?vue&type=style&index=0&id=e8131fcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8131fcc",
  null
  
)

export default component.exports